export const FRAME_CLASSIFICATION_PANEL_CONSTANTS = ({
  INSTANCE_LABEL: 'Instance',
  CANCEL_BUTTON: 'Cancel',
  CREATE_BUTTON_PREFIX: 'Create',
  SAVE_BUTTON: 'Save'
} as const);